const notification = {
	name: 'Benachrichtigung | Benachrichtigungen',
	icon: 'fa-fw fas fa-bells',
	fields: {
		type: 'Art',
		data: {
			email: 'Empfänger',
		},
		created_at: 'Versendet am',
		read_at: '@:common.readOn',
	},
}

export default notification
